/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateOrderCommand } from '../../models/update-order-command';
import { UpdateOrderCommandResult } from '../../models/update-order-command-result';

export interface ApiNurseryManagerOrdersUpdateOrderPatch$Params {
      body?: UpdateOrderCommand
}

export function apiNurseryManagerOrdersUpdateOrderPatch(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrdersUpdateOrderPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrdersUpdateOrderPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateOrderCommandResult>;
    })
  );
}

apiNurseryManagerOrdersUpdateOrderPatch.PATH = '/api/NurseryManager/Orders/UpdateOrder';
